const env = process.env.NODE_ENV
const isProd = env === 'production'

export const SUPPORTED_BROWSER = [ 'chrome', 'firefox', 'qq', 'safari' ]

export const A_HOUR = 3600000
export const A_DAY = A_HOUR * 24
export const A_MONTH = A_DAY * 30
export const A_SEASON = A_DAY * 90
export const HALF_YEAR = A_DAY * 180
export const A_YEAR = A_DAY * 365

export const SMS_TIMER = isProd ? 60 : 10
export const COUNTER_TIMER = isProd ? 5 : 1
export const STATIC_URL = process.env.VUE_APP_STATIC_HOST
export const IMAGE_APPEND = '!image.editor.post'

export const COURSE_STATUS = {
  NO_BOUGHT: 0, // 未购买
  NO_EXAM: 1, // 未参考
  NO_PASS: 2, // 未通过
  COURSE_PASS: 3, // 已通过
  EXAM_TIMEOUT: 4 // 已失效
}

// 教育程度
export const EDUCATION_TYPE = [
  { value: '1', label: '小学' },
  { value: '2', label: '初中' },
  { value: '3', label: '中专' },
  { value: '4', label: '高中' },
  { value: '5', label: '大专' },
  { value: '6', label: '本科' },
  { value: '7', label: '硕士' },
  { value: '8', label: '博士' },
  { value: '9', label: '无学历' },
]

export const SEX_TYPE = [
  { value: '1', label: '男' },
  { value: '2', label: '女' }
]

export const BROWSER_SUPPORT_STATUS = {
  NOT_TEST: 0,
  SUPPORT: 1,
  NOT_SUPPORT: 2
}

export const QUESTION_TYPE = {
  CHOOSE_SINGLE: 1, // 单选题
  CHOOSE_MULTIPLE: 2, // 多选题
  JUDGMENT: 3 // 判断题
}

export const getLabelByValue = (value, list) => {
  for (let i = 0; i < list.length; i++) {
    if (list[i].value.toString() === value.toString()) return list[i].label
  }
  return ''
}
